/* Smile.io overlay for close-on-click behavior */
document.addEventListener('DOMContentLoaded', function() {
	var smileOverlay = document.querySelector('.smile-overlay');
	if (!smileOverlay) return;

	function showSmileOverlay() {
		smileOverlay.style.opacity = '1';
		smileOverlay.style.visibility = 'visible';
		document.body.style.overflow = 'hidden';
	}

	function hideSmileOverlay() {
		smileOverlay.style.opacity = '0';
		smileOverlay.style.visibility = 'hidden';
		document.body.style.overflow = '';
	}

	smileOverlay.addEventListener('click', function() {
		if (typeof SmileUI !== 'undefined' && SmileUI.closePanel) {
			SmileUI.closePanel();
		}
		hideSmileOverlay();
	});

	var observer = new MutationObserver(function() {
		var smilePanel = document.querySelector('#smile-ui-container iframe, [class*="smile-panel"]');
		var isOpen = smilePanel && window.getComputedStyle(smilePanel).display !== 'none';

		if (!isOpen && smileOverlay.style.visibility === 'visible') {
			hideSmileOverlay();
		}
	});

	function initSmileObserver() {
		var smileContainer = document.querySelector('#smile-ui-container');
		if (smileContainer) {
			observer.observe(smileContainer, { childList: true, subtree: true, attributes: true });
		} else {
			setTimeout(initSmileObserver, 500);
		}
	}
	initSmileObserver();

	document.addEventListener('click', function(e) {
		if (e.target.closest('.thb-secondary-rewards, .thb-mobile-action-btn[title="Rewards"]')) {
			showSmileOverlay();
		}
	});
});
